module.exports = __webpack_public_path__ + "img/cp-06.afa9ab44.png";